// Small in-app notices (CFO 4.4): the undo toast after a counter tap, a goal reached — shown on the screen, never
// pushed. Web and phone each mount one host that subscribes; anything may show one.
const subs = new Set();
let seq = 0;

/** Show a notice: { title, text?, tone?: 'success' | 'warning' | 'info', action?: { label, run }, ms? }. Returns its id. */
export function showToast(t) {
  const id = ++seq;
  const toast = { id, tone: 'info', ms: 5000, ...t };
  subs.forEach((fn) => fn({ type: 'show', toast }));
  return id;
}
export const hideToast = (id) => subs.forEach((fn) => fn({ type: 'hide', id }));
export const onToast = (fn) => { subs.add(fn); return () => subs.delete(fn); };
